import type { ReactNode } from "react";
import { Link } from "react-router";

import { Emblem } from "@/components/brand/Emblem";

/**
 * Brand bar shared by account screens. The in-game HUD (M4+) has its own layout.
 * `compact`: on phones show only the emblem, for bars that also carry controls
 * (balance, log out) so nothing pushes the page wider than the screen.
 */
export function TopBar({ children, compact = false }: { children?: ReactNode; compact?: boolean }) {
  return (
    <header className="relative z-10 flex h-18 items-center justify-between gap-3 px-3 sm:gap-4 sm:px-8">
      <Link to="/" className="flex shrink-0 items-center gap-3 rounded-lg" aria-label="Coal City Life home">
        <Emblem className="size-10" />
        <span
          className={`text-headline-sm font-extrabold uppercase leading-none tracking-tight ${compact ? "hidden sm:inline" : ""}`}
        >
          Coal City Life
        </span>
      </Link>
      <div className="flex min-w-0 items-center gap-2 sm:gap-3">{children}</div>
    </header>
  );
}